<template>
    <div>
        <div>
            <vs-row vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12" vs-type="flex" class="m-2">
                <span class="ml-3 mt-3 font-bold">{{sendPedido.nombreInstitucion}}</span>
            </vs-row>
        </div>
        <!--MENU-->
        <div class="flex" style="flex-wrap:wrap;">
            <vx-tooltip style="display: inline-block;" text="Refrescar pedido" position="top" color="primary">
                <vs-button radius color="success" type="gradient" class="m-4" icon-pack="feather" icon="icon-refresh-ccw" @click="rechargePedido();"></vs-button>
            </vx-tooltip>
            <vs-button line-position="top" type="line"        class="mt-4" :class="{ 'active-institucion': menu === 0 }"   @click="menu = 0;">Institución</vs-button>
            <vs-button line-position="top" color="danger"     class="mt-4" :class="{ 'active-beneficiario': menu === 2 }"   @click="menu = 2;" v-if="sendPedido.id_pedido > 0" type="line">Beneficiario</vs-button>
            <vs-button line-position="top" line-origin="left" class="mt-4" :class="{ 'active-libros': menu === 1 }"   @click="menu = 1;" v-if="sendPedido.id_pedido > 0 && sendPedido.id_responsable > 0" color="success" type="line">Libros</vs-button>
            <vs-button line-position="top" line-origin="left" class="mt-4" :class="{ 'active-convenios': menu === 3 }"   @click="menu = 3;" v-if="sendPedido.id_pedido > 0 && sendPedido.id_responsable > 0 && !groupFacturador" color="warning" type="line">Convenios</vs-button>
            <vs-button line-position="top" line-origin="right" class="mt-4" :class="{ 'active-anticipos': menu === 4 }"   @click="rechargePedido();menu = 4;" v-if="sendPedido.id_pedido > 0 && sendPedido.id_responsable > 0" color="dark" type="line">{{groupFacturador ? 'Pagos':'Anticipos'}}</vs-button>
            <vs-button line-position="top" type="line"        class="mt-4" :class="{ 'active-verificaciones': menu === 5 }"   @click="menu = 5;" v-if="sendPedido.id_pedido > 0 && sendPedido.id_responsable > 0">Verificaciones</vs-button>
            <vs-button line-position="top" line-origin="left" class="mt-4" :class="{ 'active-seguimiento': menu === 6 }"   @click="menu = 6;" v-if="sendPedido.id_pedido > 0 && sendPedido.id_responsable > 0" color="success" type="line">Seguimiento pedido</vs-button>
            <vs-button line-position="top" type="line"        class="mt-4" :class="{ 'active-alcances': menu === 7 }"   @click="menu = 7;" v-if="(sendPedido.contrato_generado!=null || sendPedido.contrato_generado!=undefined)" color="warning">Alcances</vs-button>
            <!-- <vs-button line-position="top" type="line"        class="mt-4" :class="{ 'active-resumen': menu === 9 }"   @click="menu = 9;" v-if="(sendPedido.contrato_generado!=null || sendPedido.contrato_generado!=undefined) && groupFacturador&&!sendPedido.id_despacho" color="warning">Resumen Ventas</vs-button> -->
            <vs-button line-position="top" line-origin="left" class="mt-4" :class="{ 'active-libros-obsequios': menu === 10 }"  @click="menu = 10;" v-if="sendPedido.id_pedido > 0 && sendPedido.id_responsable > 0 " color="danger" type="line">Libros Hijos Docentes / Obsequios</vs-button>
            <vs-button line-position="top" line-origin="left" class="mt-4" :class="{ 'active-anticipos': menu === 11 }"  @click="menu = 11;" v-if="sendPedido.id_pedido > 0 && sendPedido.id_responsable > 0 && (sendPedido.contrato_generado!=null || sendPedido.contrato_generado!=undefined) && sendPedido.tipo_venta == 1" color="dark" type="line">Detalle Cobro</vs-button>
            <vs-button line-position="top" line-origin="left" class="mt-4"  :class="{ 'active-novedades': menu === 12 }"  @click="menu = 12;" color="secondary" type="line">Novedades</vs-button>
        </div>
        <!--VENTA REAL-->
        <div v-if="sendPedido.id_pedido && menu != 11">
            <BeneficiariosPorcentajeVue :pedido="sendPedido" />
        </div>
        <br>
        <!--COMPONENTES-->
        <div v-if="menu == 0">
            <ScreenInstitucion />
        </div>
        <!--LIBROS-->
        <div v-if="menu == 1">
            <ScreenLibrosVue @rechargePedido="rechargePedido" />
        </div>
        <!--BENEFICIARIO-->
        <div v-if="menu == 2 && sendPedido.id_pedido">
            <registrar_beneficiariosVue :pedido="sendPedido" @rechargePedido="rechargePedido" />
        </div>
        <!--CONVENIO-->
        <!-- <div v-if="menu == 3 && groupFacturador  || userAsesor || sendPedido.pedidos_convenios_id > 1"> -->
        <div v-if="menu == 3">
            <ScreenConvenioVue :datosInstitucion="datosInstitucion" />
        </div>
        <!--ANTICIPOS-->
        <div v-if="menu == 4 && sendPedido.id_pedido">
            <ScreenAnticiposVue @rechargePedido="rechargePedido" />
        </div>
        <!--VERIFICACIONES-->
        <div v-if="menu == 5 && sendPedido.contrato_generado">
            <ScreenVerificacionesVue />
        </div>
        <!--TRAZABILIDAD-->
        <div v-if="menu == 6 && sendPedido.id_pedido">
            <screenTransabilidaVue :pedido="sendPedido" />
        </div>
        <!--alcances-->
        <div v-if="menu == 7">
          <listadoAlcanceVue/>
        </div>
        <!--LibrosObsequios-->
        <div v-if="menu == 10">
            <librosObsequios :sendPedido="sendPedido" />
        </div>
        <!--Cobranza-->
        <div v-if="menu == 11">
            <Cobranza :sendPedido="sendPedido" />
        </div>
        <!--Observaciones-->
        <div v-if="menu == 12">
            <NovedadesVue :datosInstitucion="datosInstitucion"/>
        </div>
    </div>
    </template>
    
    <script>
    import {
        mapState
    } from "vuex";
    import PedidosRepository            from "../../../repositories/PedidosRepository";
    const BeneficiariosPorcentajeVue    = () => import('../../pedidos/components/beneficiarios/BeneficiariosPorcentaje.vue')
    const ScreenInstitucion             = () => import('./institucion/ScreenInstitucion.vue')
    const ScreenLibrosVue               = () => import('./libros/ScreenLibros.vue')
    const registrar_beneficiariosVue    = () => import('../../pedidos/registrar_beneficiarios.vue')
    const ScreenConvenioVue             = () => import('../../temporadas/components/Pedidos/Configuracion/Convenios/ScreenConvenio.vue')
    const ScreenAnticiposVue            = () => import('./anticipos/ScreenAnticipos.vue')
    const ScreenVerificacionesVue       = () => import('../verificaciones/ScreenVerificaciones.vue')
    const screenTransabilidaVue         = () => import('../../pedidos/transabilidad/screenTransabilida.vue')
    const listadoAlcanceVue             = () => import('../../pedidos/alcance/listadoAlcance.vue')
    const librosObsequios               = () => import('./libros/librosObsequios/librosObsequios.vue')
    const Cobranza                      = () => import('@/views/pedidos2/pedidos/cobranzas/asesores/asesorcobranza.vue')
    const NovedadesVue              =() => import('@/views/institucion/novedades_institucion.vue')
    export default {       
        components: {
            ScreenInstitucion,
            ScreenLibrosVue,
            BeneficiariosPorcentajeVue,
            registrar_beneficiariosVue,
            ScreenConvenioVue,
            ScreenAnticiposVue,
            ScreenVerificacionesVue,
            screenTransabilidaVue,
            listadoAlcanceVue,
            librosObsequios,
            Cobranza,
            NovedadesVue
        },
        data() {
            return {
                menu: 0,
                sendPedido: '',
                datosInstitucion: '',
            }
        },
        computed: {
            ...mapState(["auth", 'userRoot', 'susuario', 'ObjectPedido', 'groupFacturador', 'userAsesor']),
        },
        watch: {
            ObjectPedido(results) {
                let me = this
                me.sendPedido = me.ObjectPedido
            },
        },
        mounted() {
          let me = this;
          me.sendPedido = me.ObjectPedido
          me.datosInstitucion = {
            idInstitucion: me.sendPedido.id_institucion,
            nombreInstitucion: me.sendPedido.nombreInstitucion,
            id_periodo: me.sendPedido.id_periodo,
          }
          me.updateVentaReal()
          localStorage.getItem('menuNovedad');
          if (localStorage.getItem('menuNovedad')>0) {
            me.menu = parseInt(localStorage.getItem('menuNovedad'));
          }
        },
        methods: {
          rechargePedido() {
            let me = this
            PedidosRepository.getPedidoXID(me.sendPedido.id_pedido).then(r => { this.$store.dispatch('setPedido', r.data[0]); })
          },
          updateVentaReal() {
            let me = this
            if (me.groupFacturador) {
                //si es asesor envio a actualizar la venta real
                if (me.sendPedido.id_periodo == null || me.sendPedido.id_periodo == undefined) {} else {
                    const { id_asesor, id_periodo } = me.sendPedido;
                    this.$http.get(this.$server_url + `pedigo_Pagos?updateVentaReal=1&idAsesor=${id_asesor}&idPeriodo=${id_periodo}`)
                        .then(res => {})
                }
            }
          },
        }
    }
    </script>
    <style>
    .active-institucion {
        background-color: #007bff8a; /* Azul, o cualquier color que prefieras */
        color: white !important;
    }
    
    .active-beneficiario {
        background-color: #dc3546b0; /* Rojo */
        color: white !important;
    }
    
    .active-libros {
        background-color: #0ead3399; /* Verde */
        color: white !important;
    }
    
    .active-convenios {
        background-color: #ffc107; /* Amarillo */
        color: white !important;
    }
    
    .active-anticipos {
        background-color: #343a408c; /* Gris oscuro */
        color: white !important;
    }
    
    .active-verificaciones {
        background-color: #17a3b8c0; /* Cian */
        color: white !important;
    }
    
    .active-seguimiento {
        background-color: #28a74694; /* Verde */
        color: white;
        color: white !important;
    }
    
    .active-alcances {
        background-color: #fd7709af; /* Amarillo */
        color: white !important;
    }
    
    .active-resumen {
        background-color: #fd7709af; /* Amarillo */
        color: white !important;
    }
    
    .active-libros-obsequios {
        background-color: #dc35469e; /* Rojo */
        color: white !important;
    }
    .active-anticipos {
        background-color: #343a408c; /* Gris oscuro */
        color: white !important;
    }
    .active-novedades {
        background-color: #343a408c; /* Cian */
        color: white !important;
    }
    </style>
    